import _, { divide } from 'lodash'
import React from 'react'
import moment from 'moment'
import { bindActionCreators } from 'redux'
import axios from 'axios'
import config from '../../variables/config'
import { connect } from 'react-redux'
import { sendRequest } from '../../modules/admin'
import { fetchUseractions, createAction } from '../../modules/useractions'
import {
  partyEdit,
  editFinished
} from '../../modules/bookedit'
import {
  fetchParty,
  fetchUserBook,
  setUsers,
  clearFetchParty,
} from '../../modules/bookings'
import {
  changeFinished,
  newUserNotRequired,
  fetchNone,
  checkingRedirect,
  redirectDone,
  clearFetchNone,
  updateUser,
  updateWKUser
} from '../../modules/users'
import './checkbook.scss'
import { storedMoneyToPounds } from '../helpers/storedMoney'
import Alert from '../views/alert'
import IosArrowRoundBack from 'react-ionicons/lib/IosArrowRoundBack'
import IosArrowRoundForward from 'react-ionicons/lib/IosArrowRoundForward'
import IosCloseCircleOutline from 'react-ionicons/lib/IosCloseCircleOutline'

const checkbookText = 'Check booking'
const tryAgainText = 'Please try again later'
const pleaseSelectUText = 'Please select a user'
const searchText = 'Search'
const changeText = 'Change'
const noBookText = 'No bookings'
const partyBookingText = 'Party Bookings'
const partyCalendarText = 'Party Calendar'
const noPartiesText = 'No parties at this date'
const noPlayText = 'No play only tickets at this date'
const closeText = 'Close'
const onePartyText = 'party'
const morePartyText = 'parties'
const onePlayText = 'ticket'
const morePlayText = 'tickets'
const visitsText = 'Visits'
const noVisitsText = 'No visits'
const clockinText = 'In'
const clockoutText = 'Out'

const emptyAlert = {
  showAlert: false,
  message: '',
  type: '',
  callback: () => {}
}

class Checkpartybook extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      email: '',
      newEmail: '',
      firstName: '',
      lastName: '',
      address1: '',
      address2: '',
      city: '',
      country: '',
      county: '',
      postcode: '',
      phoneNumber: '',
      realm: 'civil',
      alert: _.clone(emptyAlert),
      selectedUser: {
        selected: false,
        user: {}
      },
      search: '',
      partyBookings: [],
      calendar: null,
      toClose: false,
      calendarDate: moment(),
      switchDate: moment(),
      amountsMap1: new Map(),
      amountsMap2: new Map(),
      users: [],
      doSetup: false,
      showEmail: false,
      showPhone: false,
      showNewEmail: false,
      extendedParty: 0,
      items: []
    }
  }

  componentDidMount = () => {
    let date = this.state.switchDate
    this.setState({ showNewEmail: false })

    if (this.props.redirectObj.wasRedirect) {
      if (this.props.redirectObj.user.isCalendar) {
        this.setState({
          calendar: this.props.redirectObj.user.calendarType,
          switchDate: this.props.redirectObj.user.switchDate,
          calendarDate: this.props.redirectObj.user.calendarDate
        })
        // console.log(this.props.redirectObj.user.switchDate)
        date = this.props.redirectObj.user.switchDate
      } else {
        
        this.setState({
          selectedUser: {
            selected: true,
            user: this.props.redirectObj.user,
            realm: this.state.selectedUser.user.realm
              ? this.state.selectedUser.user.realm
              : 'civil'
          }
        })
      }
      this.props.redirectDone()
      this.props.sendRequest(fetchUserBook, {
        id: this.props.redirectObj.user.id
      })
    }

    this.props.editFinished()
    this.props.sendRequest(fetchParty, { date: date })
    this.props.sendRequest(fetchNone)
    // this.getData()
  }

  componentDidUpdate() {
    if (
      this.props.fetchNoneDone &&
      this.props.fetchPartyDone
    ) {
      this.setAmounts1()
      this.props.setUsers()

      this.props.clearFetchNone()
      this.props.clearFetchParty()
    }
  }


  toggleEmail = () => {
    this.setState({ showEmail: !this.state.showEmail })
  }

  togglePhone = () => {
    this.setState({ showPhone: !this.state.showPhone })
  }

  showNewEmailInput = () => {
    this.setState({ showNewEmail: !this.state.showNewEmail })
  }

  setAmounts1 = () => {
    var datesMap = new Map()
    this.props.partyBookings.forEach(party => {
      var date = moment(party.partyDate)
      var key = date.format('D') + date.format('M') + date.format('Y')
      var value = datesMap.get(key)
      if (value) {
        value++
        datesMap.set(key, value)
      } else {
        datesMap.set(key, 1)
      }
    })
    this.setState({
      amountsMap1: datesMap
    })
  }

  clockAction = type => {
    const data = {
      type: type,
      userId: this.state.selectedUser.user.id
    }

    this.props.sendRequest(createAction, data)
  }

  handleChange = (property, { target }) => {
    this.setState({
      [property]: target.value
    })
  }

  switchWeek = toLeft => {
   
    var date = this.state.switchDate.clone()
    if (toLeft) date.subtract(1, 'week')
    else date.add(1, 'week')

    this.setState({
      switchDate: date,
      calendarDate: date
    })

  }

  updateParties = () => {
    this.props.sendRequest(fetchNone)
    this.props.sendRequest(fetchParty, { date: this.state.calendarDate })
  }

  refreshData = () => {
    this.props.sendRequest(fetchNone)
    this.props.sendRequest(fetchParty, { date: this.state.switchDate })
  }

  openCalendar = type => {
    this.setState({
      toClose: this.state.calendar === type,
      calendar: this.state.calendar === type ? null : type
    })
  }

  checkForAlert = () => {
    if (this.state.alert.showAlert) {
      return <Alert alert={this.state.alert} />
    } else if (this.props.requestFailed) {
      var alert = _.clone(emptyAlert)
      alert.type = 'error'
      alert.showAlert = true
      alert.message = tryAgainText
      alert.callback = () => {
        this.props.changeFinished()
      }

      return <Alert alert={alert} />
    } else if (this.props.requestFinished) {
      var alert2 = _.clone(emptyAlert)
      alert2.type = 'success'
      alert2.showAlert = true
      alert2.callback = () => {
        if (this.props.userForBooking.required) {
          this.animateCloseOpen(true)
        } else {
          this.props.closeWindow()
        }
        this.props.changeFinished()
      }

      return <Alert alert={alert2} />
    } else {
      return void 0
    }
  }

  animateClose = () => {
    if (this.props.userForBooking.required) this.props.newUserNotRequired()

    this.props.closeWindow()

    // this.setState({
    //   shouldClose: true
    // }, () => {
    //   setTimeout(() => {
    //     this.props.closeWindow()
    //   }, 500)
    // })
  }

  selectUser = user => {
    this.setState({
      selectedUser: {
        user: user,
        selected: true,
        membership: user.membership
      }
    })

    this.props.sendRequest(fetchUserBook, { id: user.id })
  }

  unselectUser = () => {
    this.setState({
      selectedUser: {
        user: {},
        selected: false
      }
    })
  }

  selectDate = date => {
    this.setState({
      calendarDate: date
    })
  }

  search = () => {
    var items = _.clone(this.props.users)
    if (items.users) {
      var items = _.clone(this.props.users.users)
    }
    var search = this.state.search.toLowerCase()

    var filteredItems = items.filter(item => {
      if (item.firstName.substring(0, search.length).toLowerCase() === search)
        return true
      else if (
        item.lastName.substring(0, search.length).toLowerCase() === search
      )
        return true
      else if (item.email.substring(0, search.length).toLowerCase() === search)
        return true
      else return false
    })

    return filteredItems
  }

  getSearchItems = () => {
    this.setState({items: []});
    if (this.state.search === '') this.setState({items : this.props.recentUsers})
    else this.setState({items : this.search()})

    if (!Array.isArray(this.state.items)) this.setState({items : []});

    // return (
      // <div className="searchWrapper searchBorder">
      //   {items.map((item, index) => {
      //     return (
      //       <div
      //         className={
      //           'searchRow smallText' +
      //           (index + 1 === items.length ? ' noBorder' : '')
      //         }
      //         key={index}
      //         onClick={() => this.selectUser(item)}>
      //         <div>
      //           {item.firstName + ' ' + item.lastName} -{' '}
      //           {item.adminId ? 'Site' : 'Online'}
      //         </div>
      //         <div>{item.email}</div>
      //       </div>
      //     )
      //   })}
      // </div>
    // )
  }


  navigateParty = booking => {
    // this.setState({
    //   shouldClose: true
    // }, () => {
    //   setTimeout(() => {
    if (this.state.calendar === null) {
      booking.user = this.state.selectedUser.user
    }
    this.props.partyEdit(booking)
    this.props.closeOpenWindow('party')
    if (this.state.selectedUser.selected) {
      this.props.checkingRedirect(this.state.selectedUser.user)
    } else {
      var data = {
        isCalendar: true,
        calendarType: 'party',
        switchDate: this.state.switchDate,
        calendarDate: this.state.calendarDate
      }
      this.props.checkingRedirect(data)
    }
    //   }, 500)
    // })
  }

  getVisits = () => {
    const { useractions } = this.props

    const userActions = useractions.filter(
      action => action.userId === this.state.selectedUser.user.id
    )
    const sessions = []

    userActions.forEach(action => {
      if (action.type === 'clockIn') {
        sessions.push(moment(action.date).format('DD MMM YYYY HH:mm'))
      } else if (action.type === 'clockOut') {
        sessions[sessions.length - 1] =
          sessions[sessions.length - 1] +
          ' - ' +
          moment(action.date).format('DD MMM YYYY HH:mm')
      }
    })

    return (
      <div className="searchWrapper searchBorder">
        {sessions.map((session, index) => {
          return (
            <div
              className={
                'bookingRow' +
                (index + 1 === sessions.length ? ' noBorder' : '')
              }
              key={index}>
              <div>{session}</div>
            </div>
          )
        })}
      </div>
    )
  }

  getPartyBookings = () => {
    return (
      <div className="searchWrapper searchBorder">
        {this.props.requestedUser.partyBookings.map((book, index) => {
          return (
            <div
              className={
                'bookingRow' +
                (index + 1 === this.state.partyBookings.length
                  ? ' noBorder'
                  : '')
              }
              key={index}
              onClick={() => this.navigateParty(book)}>
              <div>{book.reference}</div>
              <div>
                {book.partyTime +
                  ' ' +
                  moment(book.partyDate).format('DD/MM/YYYY')}
              </div>
            </div>
          )
        })}
      </div>
    )
  }

  getDates = type => {
    var date = this.state.switchDate
    const endDate = date.clone().endOf('week')
    endDate.add(1, 'days')
    const startDate = date.clone().startOf('week')
    startDate.add(1, 'days')

    var dates = []
    dates.push(startDate)
    var currDate = moment(startDate).startOf('day')
    var lastDate = moment(endDate).startOf('day')

    while (currDate.add(1, 'days').diff(lastDate) < 0) {
      dates.push(currDate.clone())
    }
    dates.push(endDate)

    return dates.map((date, index) => {
      var style =
        'headerDate hover' + (index === dates.length - 1 ? ' borderRight' : '')
      if (date.isSame(this.state.calendarDate, 'day')) {
        style = style + ' dateSelected'
      }
      var eventAmount = 0
      var key = date.format('D') + date.format('M') + date.format('Y')

      if (type === 'party') {
        var temp = this.state.amountsMap1.get(key)
        eventAmount = temp ? temp : 0
      } else {
        var temp2 = this.state.amountsMap2.get(key)
        eventAmount = temp2 ? temp2 : 0
      }

      return (
        <div
          key={index}
          className={style}
          onClick={() => this.selectDate(date)}>
          <div className="date">{Number(date.format('DD'))}</div>
          <div className="month">{date.format('MMM')}</div>
          {eventAmount === 1 && (
            <div className="eventAmount">
              {eventAmount +
                ' ' +
                (type === 'party' ? onePartyText : onePlayText)}
            </div>
          )}
          {eventAmount > 1 && (
            <div className="eventAmount">
              {eventAmount +
                ' ' +
                (type === 'party' ? morePartyText : morePlayText)}
            </div>
          )}
        </div>
      )
    })
  }

  getTotalAmounts = data => {
    let values = data.reduce(
      (acc, item) => {
        let partyAmount = this.getAmounts(item)

        if (
          this.state.calendarDate.isSame(moment(item.date), 'day') ||
          (item.partyDate &&
            this.state.calendarDate.isSame(moment(item.partyDate), 'day'))
        ) {
          return [acc[0] + partyAmount[0], acc[1] + partyAmount[1]]
        } else {
          return acc
        }
      },
      [0, 0]
    )

    return this.convertAmounts(values)
  }

  getTotalAmounts2 = data => {
    let values = data.reduce(
      (acc, item) => {
        let amount = this.getAmounts2(item)
        if (this.state.calendarDate.isSame(moment(item.classDate), 'day')) {
          return [acc[0] + amount[0], acc[1] + amount[1]]
        } else {
          return acc
        }
      },
      [0, 0]
    )

    return this.convertAmounts2(values)
  }

  getAmounts = item => {
    let adults,
      children = 0
    let properties = [
      'under12mnths',
      'oneYearOlds',
      'twoToThree',
      'fourAndOver',
      'adults',
      'playAndEat1to2',
      'playAndEat3andOver'
    ]

    if (!item.visitorDetails && item.attendeeDetails) {
      return [
        0,
        item.attendeeDetails.quantity + item.attendeeDetails.youngSiblings
      ]
    } else {
      properties.forEach(property => {
        if (item.visitorDetails[property]) {
          if (property === 'adults')
            adults = item.visitorDetails[property].length
          else children += item.visitorDetails[property].length
        }
      })

      return [adults, children]
    }
  }

  getAmounts2 = item => {
    let adults,
      children = 0
    for (let j = 0; j < item.tickets.length; j++) {
      children += item.tickets[j].quantity
    }
    return [adults, children]
  }

  convertAmounts = values => {
    let adults = values[0]
    let children = values[1]

    let value = ''
    if (adults === 1) value = '1 Adult '
    else if (adults > 1) value = adults + ' Adults '

    if (children === 1) value += '1 Child'
    else if (children > 1) value += children + ' Children'

    return value === '' ? 'No guests' : value
  }

  convertAmounts2 = values => {
    let adults = values[0]
    let children = values[1]

    let value = ''
    if (adults === 1) value = '1 Attendee '
    else if (adults > 1) value = adults + ' Attendees '

    if (children === 1) value += '1 Attendee'
    else if (children > 1) value += children + ' Attendees'

    return value === '' ? 'No guests' : value
  }

  

  clockActionNew = (e, type, id) => {
    e.stopPropagation()
    const data = {
      type: type,
      userId: id
    }

    this.props.sendRequest(createAction, data)
  }

  changeEmail = async () => {
    this.setState({ showNewEmail: false })
    this.setState({ email: this.state.newEmail })
    let WKUserError, OnSiteUserError
    let token = JSON.parse(window.localStorage.getItem('userData')).token
    const checkWKUser = await axios
      .get(
        config.serverURL +
          '/WKUsers/' +
          this.state.selectedUser.user.id +
          '?access_token=' +
          token
      )
      .catch(err => (WKUserError = err.response.data))
    const checkOnSiteUser = await axios
      .get(
        config.serverURL +
          '/OnSiteUsers/' +
          this.state.selectedUser.user.id +
          '?access_token=' +
          token
      )
      .catch(err => (OnSiteUserError = err.response.data))
    const newEmail = { email: this.state.newEmail }

    if (WKUserError && WKUserError.error) {
      const updateOnSiteUserEmail = await axios.patch(
        config.serverURL +
          '/OnSiteUsers/' +
          this.state.selectedUser.user.id +
          '?access_token=' +
          token,
        newEmail
      )
      this.props.updateUser({
        id: this.state.selectedUser.user.id,
        properties: newEmail
      })
    } else {
      const updateWKUserEmail = await axios.patch(
        config.serverURL +
          '/WKUsers/' +
          this.state.selectedUser.user.id +
          '?access_token=' +
          token,
        newEmail
      )
      this.props.updateWKUser({
        id: this.state.selectedUser.user.id,
        properties: newEmail
      })
    }
  }

  changeRealm = async e => {
    this.setState({ realm: e.target.value })

    let WKUserError, OnSiteUserError
    let token = JSON.parse(window.localStorage.getItem('userData')).token
    const checkWKUser = await axios
      .get(
        config.serverURL +
          '/WKUsers/' +
          this.state.selectedUser.user.id +
          '?access_token=' +
          token
      )
      .catch(err => (WKUserError = err.response.data))
    const checkOnSiteUser = await axios
      .get(
        config.serverURL +
          '/OnSiteUsers/' +
          this.state.selectedUser.user.id +
          '?access_token=' +
          token
      )
      .catch(err => (OnSiteUserError = err.response.data))
    const newRealm = { realm: this.state.realm }
    if (WKUserError && WKUserError.error) {
      const updateOnSiteUserEmail = await axios.patch(
        config.serverURL +
          '/OnSiteUsers/' +
          this.state.selectedUser.user.id +
          '?access_token=' +
          token,
        newRealm
      )

      this.props.updateUser({
        id: this.state.selectedUser.user.id,
        properties: newRealm
      })
    } else {
      const updateWKUserEmail = await axios.patch(
        config.serverURL +
          '/WKUsers/' +
          this.state.selectedUser.user.id +
          '?access_token=' +
          token,
        newRealm
      )

      this.props.updateWKUser({
        id: this.state.selectedUser.user.id,
        properties: newRealm
      })
    }
  }

  getCalendarItems = (data, property1, property2, type) => {
    
    const { useractions } = this.props
    var noParties = true
    var currentTimeslot = ''
    var timeslotVistors = 0
    var selectedDate = this.state.calendarDate
    if (data.length === 0 && !this.props.fetchNoneDone && !this.props.fetchPartyDone) {
      return (
        <div key={'partynone'} className="calendarMessage">
          {type === 'party' ? noPartiesText : noPlayText}
        </div>
      )
    }
    data.sort((a, b) => {
      if (
        moment(a[property1]).isSame(moment(b[property1]), 'day') &&
        a[property2] === b[property2]
      ) {
        if (
          a.user &&
          b.user &&
          a.user.firstName &&
          b.user.firstName &&
          moment(a.date).isSame(b.date, 'day') &&
          moment(a.date).isSame(selectedDate, 'day')
        ) {
          var textA = a.user.firstName.toUpperCase()
          var textB = b.user.firstName.toUpperCase()
          return textA < textB ? -1 : textA > textB ? 1 : 0
        }
      } else {
        return 0
      }
    })

    return data.map((item, index) => {
      if (!item.user) {
        return <div key={index}></div>
      }

      var date = moment(item[property1])
      // var selectedDate = this.state.calendarDate;
      var found = false
      var showTime = false
      if (
        date.isSame(selectedDate, 'day') &&
        date.isSame(selectedDate, 'month') &&
        date.isSame(selectedDate, 'year')
      ) {
        found = true
        noParties = false
        var slotsBookings = []
        if (currentTimeslot !== item[property2]) {
          showTime = true
          currentTimeslot = item[property2]
          slotsBookings = data.filter(function(booking) {
            if (booking.partyDate) {
              return (
                moment(booking.partyDate).isSame(selectedDate, 'day') &&
                booking.partyTime === currentTimeslot
              )
            } else {
              return (
                moment(booking.date).isSame(selectedDate, 'day') &&
                booking.time === currentTimeslot
              )
            }
          })
          timeslotVistors = this.getTotalAmounts(slotsBookings)
        }
        
      }
      
      if (index === data.length - 1 && !found && noParties && !this.props.fetchNoneDone && !this.props.fetchPartyDone) {
        return (
          <div key={index} className="calendarMessage">
            {type === 'party' ? noPartiesText : noPlayText}
          </div>
        )
      }

      

      let amounts = this.convertAmounts(this.getAmounts(item))

      if (amounts !== '') amounts = amounts + ' - '
      var message =
        (type === 'party' ? item.partyType + '  -  ' : amounts) +
        item.user.firstName +
        ' ' +
        item.user.lastName +
        ' ' +
        (item.onsiteUserId ? '[SITE]' : '') +
        (item.note && item.note.length > 1 ? ' -  *Note: ' + item.note : '')
    
      var userActions = useractions.filter(
        action => action.userId === item.user.id
      )
      var latestAction = null
      userActions.forEach(action => {
        if (
          selectedDate.isSame(moment(action.date), 'day') &&
          selectedDate.isSame(moment(action.date), 'month') &&
          selectedDate.isSame(moment(action.date), 'year')
        ) {
          if (
            action.type === 'clockInBooking' ||
            action.type === 'clockOutBooking'
          ) {
            latestAction = action
          }
        }
      })

      return found ? (
        <div>
        <div
          className={'calendarParty' + (showTime ? ' marginTop' : '')}
          key={index}>
          <div className="calendarTime">
            {showTime ? currentTimeslot : ''} {showTime ? timeslotVistors : ''}
          </div>
          <div
            className="calendarDetails"
            onClick={
              type === 'party'
                ? () => this.navigateParty(item)
                : () => {}
            }>
            <span
              className={
                item.user.realm === 'warning'
                  ? 'warning'
                  : item.user.realm === 'problematic'
                  ? 'problematic'
                  : item.user.realm === 'influencer'
                  ? 'influencer'
                  : ''
              }>
              {message}
              
            </span>
            {type === 'party' && item.timeToChange && (
              <div className="rescheduleLabel">To be reschedule</div>
            )}
            {type === 'party' ? (
              ''
            ) : latestAction ? (
              <span className="marginLeft">✓</span>
            ) : (
              <span></span>
            )}
          </div>
          {type === 'party' ? <span style={{marginLeft:'20px'}} onClick={
               () => this.setState({extendedParty : index})
            }> More details</span> : <></>}
            
          {this.state.showEmail ? (
            <div className="calendarEmail">
              {this.state.showEmail ? item.user.email : ''}
            </div>
          ) : (
            <span />
          )}
          {this.state.showPhone ? (
            <div className="calendarEmail">
              {this.state.showPhone ? item.user.phoneNumber : ''}
            </div>
          ) : (
            <span />
          )}
          <div
            className={
              latestAction
                ? 'buttonWrapper marginLeft marginRight nonVisible'
                : 'buttonWrapper marginLeft marginRight'
            }
            onClick={e =>
              this.clockActionNew(e, 'clockInBooking', item.user.id)
            }>
            {clockinText}
          </div>
          <div
            className="buttonWrapper out"
            onClick={e =>
              this.clockActionNew(e, 'clockOutBooking', item.user.id)
            }>
            {clockoutText}
          </div>
        </div>
        {type === 'party' && this.state.extendedParty === index ? 
          <div style={{marginLeft: '11%', color: 'white'}}>
            <div>Children Number: {item.attendeeDetails.quantity}</div>
            <div>Birthday Child: {item.additionalDetails.whoIsPartyFor} | {item.additionalDetails.partyChildGender}</div>
            <div>Total Bill: {item.attendeeDetails.totalPrice / 100}</div>
            <div>Deposit Paid: {item.attendeeDetails.totalDeposit ? storedMoneyToPounds(item.attendeeDetails.totalDeposit, item.attendeeDetails.totalPrice) : 'Open Party Page to Check'}</div>
            <div> Extras: 
             {item.extraItems.filter((extra) => extra.quantity > 0).map((extra) => {
                return <div><b>{extra.name}</b>  £{extra.price / 100} x {extra.quantity} </div>
            })}
            </div>
            <div> Themes 
             {item.themeItems && item.themeItems.filter((theme) => theme.quantity > 0).map((theme) => {
                return <div><b>{theme.name}</b>  £{theme.price / 100} x {theme.quantity} </div>
            })}
            </div>
            <div> Mascot: 
             {item.mascotItems && item.mascotItems.filter((mascot) => mascot.quantity > 0).map((mascot) => {
                return <div><b>{mascot.name}</b> £{mascot.price / 100} x {mascot.quantity}</div>
            })}
            </div>
            <div> Note: {item.note} </div>
          </div> : <></>}
        </div>
      ) : (
        void 0
      )
    })
  }

  getCalendarItems2 = (data, property1, property2, type) => {
    const { useractions } = this.props
    var currentTimeslot = ''
    var timeslotVistors = 0
    var selectedDate = this.state.calendarDate
    data.sort((a, b) => {
      if (
        moment(a[property1]).isSame(moment(b[property1]), 'day') &&
        a[property2] === b[property2]
      ) {
        if (
          a.user &&
          b.user &&
          a.user.firstName &&
          b.user.firstName &&
          moment(a.classDate).isSame(b.classDate, 'day') &&
          moment(a.classDate).isSame(selectedDate, 'day')
        ) {
          var textA = a.user.firstName.toUpperCase()
          var textB = b.user.firstName.toUpperCase()
          return textA < textB ? -1 : textA > textB ? 1 : 0
        }
      } else {
        return 0
      }
    })

    return data.map((item, index) => {
      if (!item.user) {
        return <div key={index}></div>
      }

      var date = moment(item[property1])
      var found = false
      var showTime = false
      var slotsBookings = []
      if (
        date.isSame(selectedDate, 'day') &&
        date.isSame(selectedDate, 'month') &&
        date.isSame(selectedDate, 'year')
      ) {
        found = true
        if (currentTimeslot !== item[property2]) {
          showTime = true
          currentTimeslot = item[property2]
          slotsBookings = data.filter(
            booking =>
              moment(booking.classDate).isSame(selectedDate, 'day') &&
              booking.classTime === currentTimeslot
          )

          timeslotVistors = this.getTotalAmounts2(slotsBookings)
        }
      }

      let amounts = this.convertAmounts(this.getAmounts2(item))

      if (amounts !== '') amounts = amounts + ' - '
      let tickets = []
      for (let j = 0; j < item.tickets.length; j++) {
        tickets.push(item.tickets[j].name + ' * ' + item.tickets[j].quantity)
      }
      var message =
        item.className +
        '  -  ' +
        item.user.firstName +
        ' ' +
        item.user.lastName +
        '  ( ' +
        tickets.join(' | ') +
        ' ) '
      var userActions = useractions.filter(
        action => action.userId === item.user.id
      )
      var latestAction = null
      userActions.forEach(action => {
        if (
          selectedDate.isSame(moment(action.date), 'day') &&
          selectedDate.isSame(moment(action.date), 'month') &&
          selectedDate.isSame(moment(action.date), 'year')
        ) {
          if (
            action.type === 'clockInBooking' ||
            action.type === 'clockOutBooking'
          ) {
            latestAction = action
          }
        }
      })

      return found ? (
        <div
          className={'calendarParty' + (showTime ? ' marginTop' : '')}
          key={index}>
          <div className="calendarTime">
            {showTime ? currentTimeslot : ''} {showTime ? timeslotVistors : ''}
          </div>
          <div className="calendarDetails">
            <span
              className={
                item.user.realm === 'warning'
                  ? 'warning'
                  : item.user.realm === 'problematic'
                  ? 'problematic'
                  : item.user.realm === 'influencer'
                  ? 'influencer'
                  : ''
              }>
              {message}
            </span>
            {latestAction ? (
              <span className="marginLeft">✓</span>
            ) : (
              <span></span>
            )}
          </div>
          {this.state.showEmail ? (
            <div className="calendarEmail">
              {this.state.showEmail ? item.user.email : ''}
            </div>
          ) : (
            <span />
          )}
          {this.state.showPhone ? (
            <div className="calendarEmail">
              {this.state.showPhone ? item.user.phoneNumber : ''}
            </div>
          ) : (
            <span />
          )}
          <div
            className={
              latestAction
                ? 'buttonWrapper marginLeft marginRight nonVisible'
                : 'buttonWrapper marginLeft marginRight'
            }
            onClick={e =>
              this.clockActionNew(e, 'clockInBooking', item.user.id)
            }>
            {clockinText}
          </div>
          <div
            className="buttonWrapper out"
            onClick={e =>
              this.clockActionNew(e, 'clockOutBooking', item.user.id)
            }>
            {clockoutText}
          </div>
        </div>
        
      ) : (
        void 0
      )
    })
  }

  render() {
    return (
      <div
        className={
          'checkbookWindow' + (this.state.shouldClose ? ' closeWindow' : '')
        }>
        {this.props.fetchNoneDone || this.props.fetchPartyDone ? 
          <div>Loading...</div> : <span></span> }
        <div
          className={
            'checkbookForm' +
            (this.state.calendar === null
              ? this.state.toClose
                ? ' notCalendar'
                : ''
              : ' isCalendar')
          }>
          <IosCloseCircleOutline
            onClick={() => this.animateClose()}
            className="closeIcon"
            fontSize="30px"
            color="#fff"
          />
          {this.props.userForBooking.required ? (
            <IosArrowRoundBack
              onClick={() => this.animateCloseOpen()}
              className="backIcon"
              fontSize="45px"
              color="#fff"
            />
          ) : (
            void 0
          )}
          <div className="titleText">{checkbookText}</div>
          {this.state.calendar === null && (
            <div>
              {!this.state.selectedUser.selected ? (
                <div className="searchWindow">
                  <div className="subtitleText">{pleaseSelectUText}</div>
                  <div className="inputWrapper">
                    <input
                      type="text"
                      value={this.state.search}
                      disabled={this.props.requestLoading}
                      onChange={e => this.setState({ search: e.target.value })}
                      placeholder={searchText}
                    />
                    
                  </div>
                  <div className="inputWrapper">
                  <button
                          className='buttonWrapper' 
                          type="submit"
                          onClick={this.getSearchItems}>
                          Search
                    </button>
                    </div>
                    <div className="searchWrapper searchBorder">
                      {this.state.items.map((item, index) => {
                        return (
                          <div
                            className={
                              'searchRow smallText' +
                              (index + 1 === this.state.items.length ? ' noBorder' : '')
                            }
                            key={index}
                            onClick={() => this.selectUser(item)}>
                            <div>
                              {item.firstName + ' ' + item.lastName} -{' '}
                              {item.adminId ? 'Site' : 'Online'}
                            </div>
                            <div>{item.email}</div>
                          </div>
                        )
                      })}
                    </div>
                  
                  <div style={{ height: 30 }}></div>
                </div>
              ) : (
                <div className="searchWrapper selectedWrapper">
                  <div className="searchRow smallText selectedRow">
                    <div>
                      <div>
                        {this.state.selectedUser.user.firstName +
                          ' ' +
                          this.state.selectedUser.user.lastName}
                      </div>
                      <div>{this.state.selectedUser.user.email}</div>
                      <div>{this.state.selectedUser.user.phoneNumber}</div>
                      <div style={{ display: 'flex' }}>
                        {/* <button className="refreshButton inputs hoverOptions optionInputs" style={{marginRight:'10px'}} onClick={this.showNewEmailInput}>Edit Email</button> */}

                        <select
                          value={
                            this.state.selectedUser.user.realm
                              ? this.state.selectedUser.user.realm
                              : this.state.realm
                          }
                          className={
                            'refreshButton inputs hoverOptions optionInputs ' +
                            (this.state.selectedUser.user.realm &&
                            this.state.selectedUser.user.realm === 'influencer'
                              ? 'influencer'
                              : this.state.selectedUser.user.realm === 'warning'
                              ? 'warning'
                              : this.state.selectedUser.user.realm ===
                                'problematic'
                              ? 'problematic'
                              : 'civil')
                          }
                          onChange={e => this.changeRealm(e)}>
                          <option value="civil">civil</option>
                          <option value="influencer">Influencer</option>
                          <option value="warning">warning</option>
                          <option value="problematic">problematic</option>
                        </select>
                      </div>
                    </div>
                    {this.state.showNewEmail && (
                      <div style={{ display: 'flex' }}>
                        <input
                          className="refreshButton inputs editEmail optionInputs"
                          onFocus={e => (e.target.value = '')}
                          onBlur={e => (e.target.value = 'Enter new email')}
                          on
                          style={{ marginRight: '10px' }}
                          type="text"
                          defaultValue="Enter new email"
                          onChange={e =>
                            this.setState({ newEmail: e.target.value })
                          }
                        />
                        <button
                          className="refreshButton inputs hoverOptions optionInputs"
                          type="submit"
                          onClick={this.changeEmail}>
                          Submit
                        </button>
                      </div>
                    )}
                  </div>
                  {!this.state.paymentDone && (
                    <div
                      className="searchChange"
                      onClick={() => this.unselectUser()}>
                      {changeText}
                    </div>
                  )}
                </div>
              )}
            </div>
          )}
          {this.state.selectedUser.selected && this.state.calendar === null && (
            <div>
              <div className="subtitleText">{visitsText}</div>
              <div className="bookingWrapper">
                {this.state.selectedUser.selected ? (
                  <div>{this.getVisits()}</div>
                ) : (
                  <div className="noBookLabel">{noVisitsText}</div>
                )}
                <div className="checkButtons">
                  <div
                    className="buttonWrapper extraMargin"
                    onClick={() => this.clockAction('clockOut')}>
                    {clockoutText}
                  </div>
                  <div
                    className="buttonWrapper"
                    onClick={() => this.clockAction('clockIn')}>
                    {clockinText}
                  </div>
                </div>
              </div>
              <div className="bookingWrapper">
               
              </div>
              <div className="subtitleText">{partyBookingText}</div>
              <div className="bookingWrapper">
                {this.state.selectedUser.selected ? (
                  <div>{this.getPartyBookings()}</div>
                ) : (
                  <div className="noBookLabel">{noBookText}</div>
                )}
              </div>
              <div className="bookingWrapper">
                
              </div>
            </div>
          )}
          {!this.state.selectedUser.selected && (
            <div className="buttonsWrapper">
              <div
                className={
                  'calendarButton' +
                  (this.state.calendar === 'party' ? ' selected' : '')
                }
                onClick={() => this.openCalendar('party')}>
                {this.state.calendar === 'party'
                  ? closeText
                  : partyCalendarText}
              </div>
             
            </div>
          )}
          {(this.state.calendar === 'play' ||
            this.state.calendar === 'party') && (
            <div className="refreshWrapper">
             
              <div
                className="buttonWrapper"
                style={{ marginLeft: '20px' }}
                onClick={this.toggleEmail}>
                {this.state.showEmail ? 'Hide Email' : 'Show Email'}
              </div>
              <div
                className="buttonWrapper"
                style={{ marginLeft: '20px' }}
                onClick={this.togglePhone}>
                {this.state.showPhone ? 'Hide Phone' : 'Urgent Contact'}
              </div>
              <div className="refreshButton" 
                    style={{ marginLeft: '20px' }}
                    onClick={this.updateParties}>
                Check
              </div>
              <div style={{color:'white', lineHeight:'40px'}}>Please click the Check button every time switch to a new week</div>
            </div>
          )}

          {this.state.calendar === 'party' && (
            <div>
              <div className="calendar">
                <div className="calendarHeader">
                  <IosArrowRoundBack
                    onClick={() => this.switchWeek(true)}
                    className="headerLeft hover"
                    fontSize="45px"
                    color="#fff"
                  />
                  {this.getDates('party')}
                  <IosArrowRoundForward
                    onClick={() => this.switchWeek(false)}
                    className="headerRight hover"
                    fontSize="45px"
                    color="#fff"
                  />
                </div>
                {this.props.fetchNoneDone || this.props.fetchPartyDone ? <div style={{color:'white'}}>Loading... </div> : <div></div>}
                {this.getCalendarItems(
                  this.props.partyBookings,
                  'partyDate',
                  'partyTime',
                  'party'
                )}
              </div>
            </div>
          )}
    
        </div>
        {this.checkForAlert()}
      </div>
    )
  }
}

const mapStateToProps = ({ users, bookings, useractions }) => ({
  users: users.users,
  useractions: useractions.data,
  redirectObj: users.redirectObj,
  recentUsers: users.recentUsers,
  fetchNoneDone: users.fetchNoneDone,
  requestFailed: users.requestFailed,
  userForBooking: users.userForBooking,
  requestLoading: users.requestLoading,
  requestedUser: bookings.requestedUser,
  partyBookings: bookings.partyBookings,
  requestFinished: users.requestFinished,
  fetchPartyDone: bookings.fetchPartyDone,
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      sendRequest,
      clearFetchNone,
      changeFinished,
      newUserNotRequired,
      partyEdit,
      checkingRedirect,
      redirectDone,
      editFinished,
      setUsers,
      clearFetchParty,
      updateUser,
      updateWKUser
    },
    dispatch
  )

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Checkpartybook)
